import type { FC } from 'react';
import React from 'react';
import type { DropdownMenuProps as RadixDropdownMenuProps } from '@radix-ui/react-dropdown-menu';
import { Root } from '@radix-ui/react-dropdown-menu';

type DropdownMenuProps = RadixDropdownMenuProps;

const DropdownMenu: FC<DropdownMenuProps> = ({ children, ...props }) => <Root {...props}>{children}</Root>;

export default DropdownMenu;
